










import { defineComponent } from '@vue/composition-api';
import { useVoiceClass } from '@/bundles/VideoContent/composables/useVoiceClass';

import VoiceClassBaseForm from './VoiceClassBaseForm.vue';


export default defineComponent({
  name: 'VoiceClassEditForm',

  components: {
    VoiceClassBaseForm,
  },

  props: {
    voiceClass: {
      type: Object,
      required: true,
    },
  },

  emits: ['updated'],

  setup(props, {emit}) {
    const {updateVoiceClass} = useVoiceClass();
    const saveVoiceClass = async (formData: any) => {
      await updateVoiceClass(props.voiceClass.id, formData);
      emit('updated');
    };

    return {
      saveVoiceClass,
    };
  },
});
